import { render, staticRenderFns } from "./ViaChart.vue?vue&type=template&id=05e2f862&scoped=true&"
import script from "./ViaChart.vue?vue&type=script&lang=js&"
export * from "./ViaChart.vue?vue&type=script&lang=js&"
import style0 from "./ViaChart.vue?vue&type=style&index=0&id=05e2f862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e2f862",
  null
  
)

export default component.exports